define('common/views/sidebar_view_mdsidebar',['require','exports','module','backbone','react','react-dom','mdsidebarjs','ServicesHelper','i18n','ThemesHelper','services/auth/info','common/models/appstate'],function (require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
    React = require('react'),
    ReactDOM = require('react-dom'),
    MDSidebar = require('mdsidebarjs'),
    ServicesHelper = require('ServicesHelper'),
    i18n = require('i18n'),
    ThemesHelper = require('ThemesHelper'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo(),
    AppState = require('common/models/appstate');

  var Sidebar = Backbone.View.extend({
    userLang: i18n.lng(),
    services: [],
    initialize: function (options) {
      this.options = options;
      this.userLang = i18n.lng();

      this.loadServices();

      if (AppState._companyInfo) {
        this.listenTo(AppState._companyInfo, 'all', this.render);
      }
    },

    loadServices: function () {
      // Search in local storage for services:
      if (
        localStorage.getItem(this.getStoreKeyServices()) &&
        JSON.parse(localStorage.getItem(this.getStoreKeyServices())).length > 0
      ) {
        this.services = JSON.parse(localStorage.getItem(this.getStoreKeyServices()));
        this.render();
      } else {
        $.when(ServicesHelper.getServices()).done(
          function (response) {
            this.services = ServicesHelper.parseServices(response._embedded.services);
            if (this.isGoodDataService(response._embedded.services)) {
              localStorage.setItem(this.getStoreKeyServices(), JSON.stringify(this.services));
            }
            this.render();
          }.bind(this)
        );
      }
    },

    getStoreKeyServices: function () {
      return 'my-services-' + authInfo.getGroupId() + '-' + authInfo.getUserId();
    },

    isGoodDataService: function (services) {
      if (!services || !services.length) {
        return false;
      }
      var valid = true;
      services.map(function (service) {
        if (!service.rolId) valid = false;
      });

      return valid;
    },
    setUserLang: function (lang) {
      this.userLang = lang;
      return this;
    },

    render: function () {
      var sidebarOptions = {
        theme: ThemesHelper.getCurrentTheme(),
        lang: this.userLang,
        servicesConfig: this.services,
        preventDefaultLinks: true,
        companyId: authInfo.getCompanyId(),
        groupId: authInfo.getGroupId(),
        userId: authInfo.getUserId(),
      };
      // merge options with default options
      sidebarOptions = Object.assign(sidebarOptions, this.options);
      ReactDOM.render(React.createElement(MDSidebar.MDSidebar, sidebarOptions), this.el);

      return this;
    },
  });
  module.exports = Sidebar;
});

